import { css, useTheme } from '@fable/theme'
import { CompProps } from 'types'
import { GridCalloutTheme } from './types'

interface Props {
  theme: GridCalloutTheme
}

export const GridCalloutImageBox = ({ children, theme }: CompProps<Props>) => {
  const { mediaQueries } = useTheme()

  return (
    <div
      className={css`
        position: relative;
        width: 100%;
        height: 85.714vw;
        background-color: ${theme.light};
        border-radius: 7.143vw;
        ${mediaQueries.mobileL} {
          width: calc(50% - 16px);
          height: 43.403vw;
          border-radius: 3.472vw;
        }
        ${mediaQueries.desktop} {
          height: 500px;
          border-radius: 40px;
        }
      `}
    >
      {children}
      <span
        className={css`
          display: block;
          width: calc(100% + 4.8vw);
          height: 15%;
          position: absolute;
          inset: auto auto -2.4vw 50%;
          transform: translateX(-50%);
          border: 2.4vw solid white;
          background-color: transparent;
          border-top-color: transparent;
          border-bottom-right-radius: 9.7vw;
          border-bottom-left-radius: 9.7vw;
          pointer-events: none;
          z-index: 1;
          ${mediaQueries.mobileL} {
            width: calc(100% + 1.736vw);
            border-bottom-right-radius: 4.472vw;
            border-bottom-left-radius: 4.472vw;
            border-width: 0.868vw;
            bottom: -0.868vw;
          }
          ${mediaQueries.desktop} {
            width: calc(100% + 20px);
            border-bottom-right-radius: 50px;
            border-bottom-left-radius: 50px;
            bottom: -10px;
            border-width: 10px;
          }
        `}
      />
    </div>
  )
}
